import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_GET_STATE_SUCCESS,
  COMMISSIONS_GET_STATE_FAILURE
} from '../constants'

export function* getCommissionsStateSaga({params}) {
  try {
      const state =  yield call(BFFAgent.Commission.getCommissionsState, params)

      yield put({
          type: COMMISSIONS_GET_STATE_SUCCESS,
          data: state
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_STATE_FAILURE,
      data: { error }
    })
  }
}